export const items = [
	{
		type: 'men',
		links: [ "Men's Gi", "Men's Hoodie", "Men's Pants", "Men's Shirt" ]
	},
	{
		type: 'women',
		links: [ "Women's Gi", "Women's Hoodie", "Women's Pants", "Women's Shirt" ]
	},
	{
		type: 'kid',
		links: [ "Kid's Gi", "Kid's Hoodie", "Kid's Pants", "Kid's Shirt" ]
	},
	{
		type: 'mma',
		links: [ 'Gloves', 'Head-Guards', 'Mouth-Guards', 'Shin-Guards' ]
	}
];
